<div class="flex items-center justify-center dialog-header " *ngIf="showHeader">
    Preview Email Template

    <div class="absolute right-2 flex gap-0 items-center">
        <button (click)="handleCloseDialog()" class="outline-none pl-1 pr-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="whatsapp-ui-box"
    [style.height]="type === 'email' ? '75vh' : '50vh'"
    >
        <div class="preview-box" style="height: 100%;">
            <!-- Bind sanitized HTML to srcdoc in iframe -->
            <iframe [srcdoc]="sanitizedData"  class="preview-iframe"></iframe>
        </div>
        
        <!-- Documents Section -->
        <div *ngIf="documents && documents.length > 0" class="mt-3 p-3 border-t border-gray-200">
            <div class="font-semibold mb-2 text-sm">Attachments ({{documents.length}})</div>
            <div class="grid grid-cols-4 gap-3">
                <div *ngFor="let document of documents" 
                     class="flex flex-col gap-2 p-2 bg-gray-50 rounded border border-gray-200 hover:bg-gray-100">
                    
                    <!-- Image Preview -->
                    <div *ngIf="getFileTypeFromUrl(document) === 'image'" 
                         class="w-full h-32 overflow-hidden rounded border border-gray-300 bg-white flex items-center justify-center">
                        <img [src]="document" 
                             [alt]="getFileNameFromUrl(document)"
                             class="max-w-full max-h-full object-contain"
                            >
                    </div>

                    <!-- Video Preview -->
                    <div *ngIf="getFileTypeFromUrl(document) === 'video'" 
                         class="w-full h-32 overflow-hidden rounded border border-gray-300 bg-black flex items-center justify-center">
                        <video [src]="document" 
                               class="max-w-full max-h-full object-contain"
                               controls
                               preload="metadata">
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    <!-- Document Icon for PDFs, DOCs, etc. -->
                    <div *ngIf="getFileTypeFromUrl(document) === 'document'" 
                         class="w-full h-32 flex items-center justify-center bg-blue-50 rounded border border-gray-300">
                        <i [class]="'pi ' + getFileIcon('document') + ' text-6xl text-blue-600'"></i>
                    </div>

                    <!-- File Info and Actions -->
                    <div class="flex items-center gap-2">
                        <div class="flex-1 overflow-hidden">
                            <div class="text-xs font-medium truncate text-gray-800" [title]="getFileNameFromUrl(document)">
                                {{getFileNameFromUrl(document)}}
                            </div>
                            <div class="text-xs text-gray-500 capitalize">{{getFileTypeFromUrl(document)}}</div>
                        </div>
                        <a [href]="document" target="_blank" 
                           class="text-blue-600 hover:text-blue-800 p-1.5 rounded hover:bg-blue-100">
                            <i class="pi pi-external-link text-sm"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
